module.exports = __webpack_public_path__ + "static/media/country_pt.31f2dee3.webp";